/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SendLeadReferralResponse } from './SendLeadReferralResponse';
import {
    SendLeadReferralResponseFromJSON,
    SendLeadReferralResponseFromJSONTyped,
    SendLeadReferralResponseToJSON,
} from './SendLeadReferralResponse';

/**
 * 
 * @export
 * @interface SendLeadReferral201Response
 */
export interface SendLeadReferral201Response {
    /**
     * 
     * @type {SendLeadReferralResponse}
     * @memberof SendLeadReferral201Response
     */
    data?: SendLeadReferralResponse;
}

/**
 * Check if a given object implements the SendLeadReferral201Response interface.
 */
export function instanceOfSendLeadReferral201Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SendLeadReferral201ResponseFromJSON(json: any): SendLeadReferral201Response {
    return SendLeadReferral201ResponseFromJSONTyped(json, false);
}

export function SendLeadReferral201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SendLeadReferral201Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : SendLeadReferralResponseFromJSON(json['data']),
    };
}

export function SendLeadReferral201ResponseToJSON(value?: SendLeadReferral201Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': SendLeadReferralResponseToJSON(value.data),
    };
}

